<nav class="sidebar">
  <div class="sidebar-header">
    <!--- Logo -->
    <a routerLink="/" class="sidebar-brand nobleui-logo logo-light">
      <img
        class="dark-theme-logo"
        src="../../../../assets/images/logo-light.png"
      />
      <img
        class="light-theme-logo"
        src="../../../../assets/images/logo-dark.png"
      />
    </a>

    <!-- <a routerLink="/" class="sidebar-brand nobleui-logo logo-light">
      <img src="assets/images/logo.png" alt="logo">
    </a> -->

    <!--- Toggler -->
    <div
      class="sidebar-toggler active"
      #sidebarToggler
      (click)="toggleSidebar($event)"
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div
    class="sidebar-body"
    (mouseenter)="operSidebarFolded()"
    (mouseleave)="closeSidebarFolded()"
    [perfectScrollbar]
  >
    <!--- Sidemenu start -->

    <ul class="sidebar-nav metismenu" id="sidebar-menu" #sidebarMenu>
      <ng-container *ngFor="let item of menuItems">
        <li class="nav-item nav-category" *ngIf="item.isTitle">
          {{ item.label }}
        </li>

        <li class="nav-item" *ngIf="!item.isTitle">
          <!-- with submenus -->
          <a
            class="nav-link"
            *ngIf="hasItems(item) && !item.disabled"
            href="javascript:void(0);"
          >
            <i
              class="link-icon"
              [attr.data-feather]="item.icon"
              appFeatherIcon
              *ngIf="item.icon"
            ></i>
            <span class="link-title"> {{ item.label }}</span>
            <span
              class="link-arrow"
              data-feather="chevron-down"
              appFeatherIcon
            ></span>
          </a>

          <!-- without submenus -->
          <a
            class="nav-link nav-link-ref"
            [routerLink]="item.link"
            *ngIf="!hasItems(item) && !item.disabled"
            [attr.data-parent]="item.parentId"
          >
            <i
              class="link-icon"
              [attr.data-feather]="item.icon"
              appFeatherIcon
              *ngIf="item.icon"
            ></i>
            <span class="link-title"> {{ item.label }}</span>
            <span
              class="badge bg-{{ item.badge.variant }}"
              *ngIf="item.badge"
              >{{ item.badge.text }}</span
            >
          </a>

          <ul
            class="sidebar-nav sub-menu nav-second-level"
            *ngIf="hasItems(item)"
            aria-expanded="false"
          >
            <li
              class="nav-item"
              *ngFor="let subitem of item.subItems"
              [ngClass]="{ 'side-nav-item': hasItems(subitem) }"
            >
              <a
                class="nav-link side-nav-link-a-ref"
                *ngIf="hasItems(subitem)"
                href="javascript:void(0);"
              >
                <i
                  class="link-icon"
                  [attr.data-feather]="subitem.icon"
                  appFeatherIcon
                  *ngIf="subitem.icon"
                ></i>
                <span class="link-title"> {{ subitem.label }}</span>
                <span
                  class="link-arrow"
                  data-feather="chevron-down"
                  appFeatherIcon
                ></span>
              </a>
              <!-- submenus -->
              <a
                class="nav-link nav-link-ref"
                [routerLink]="subitem.link"
                *ngIf="!hasItems(subitem) && !subitem.disabled"
                [attr.data-parent]="subitem.parentId"
              >
                <i
                  class="link-icon"
                  [attr.data-feather]="subitem.icon"
                  appFeatherIcon
                  *ngIf="subitem.icon"
                ></i>
                {{ subitem.label }}
              </a>

              <ul
                class="sidebar-nav sub-menu nav-third-level"
                *ngIf="hasItems(subitem)"
                aria-expanded="false"
              >
                <li
                  class="nav-item"
                  *ngFor="let subSubitem of subitem.subItems"
                >
                  <a
                    class="nav-link nav-link-ref"
                    [routerLink]="subSubitem.link"
                    [routerLinkActive]="['active']"
                    [attr.data-parent]="subSubitem.parentId"
                  >
                    <i
                      class="link-icon"
                      [attr.data-feather]="subitem.icon"
                      appFeatherIcon
                      *ngIf="subitem.icon"
                    ></i>
                    {{ subSubitem.label }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ng-container>
      <!-- <li class="nav-item nav-category">Docs</li>
      <li class="nav-item">
        <a
          href="https://www.nobleui.com/angular/documentation/docs.html"
          target="_blank"
          class="nav-link"
        >
          <i class="link-icon" data-feather="hash" appFeatherIcon></i>
          <span class="link-title">Documentation</span>
        </a>
      </li> -->
    </ul>

    <!--- Sidemenu end -->
    <!--- Sidemenu 2 start -->

    <ul class="sidebar-nav metismenu border-top" id="sidebar-menu-2">
      <ng-container>
        <li class="nav-item update-link">
          <button (click)="updateApplication()" class="btn btn-info btn-update">
            <i class="feather icon-info update-closed"></i>
            <div class="update-open">
              New Version Available <strong>UPDATE NOW</strong>
            </div>
          </button>
        </li>

        <li class="nav-item">
          <!-- without submenus -->
          <a class="nav-link nav-link-ref" routerLink="/settings">
            <!-- add settings feather icon -->
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="link-icon feather feather-settings"
            >
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a2 2 0 0 1 0 2.6"></path>
              <path d="M4.6 15a2 2 0 0 1 0-2.6"></path>
              <path
                d="M12 19c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
              ></path>
            </svg>
            <span class="link-title"> Settings</span> -->
            <i
              class="link-icon"
              [attr.data-feather]="'settings'"
              appFeatherIcon
            ></i>
            <span class="link-title"> Settings</span>
          </a>
        </li>
        <li class="nav-item switch-link">
          <div class="switch-text">
            <span id="sunIcon" class="feather icon-sun"></span>
            <span id="moonIcon" class="feather icon-moon"></span>
            <div class="switch-menu-text">Switch Mode</div>
          </div>
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" />
            <label class="custom-control-label" for="themeSwitch"></label>
          </div>
        </li>

        <li class="nav-item">
          <!-- without submenus -->
          <a class="nav-link nav-link-ref">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="link-icon feather feather-log-out"
            >
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span class="link-title"> Logout</span>
          </a>
        </li>
      </ng-container>
      <!-- <li class="nav-item nav-category">Docs</li>
      <li class="nav-item">
        <a
          href="https://www.nobleui.com/angular/documentation/docs.html"
          target="_blank"
          class="nav-link"
        >
          <i class="link-icon" data-feather="hash" appFeatherIcon></i>
          <span class="link-title">Documentation</span>
        </a>
      </li> -->
    </ul>

    <!--- Sidemenu 2 end -->
  </div>
</nav>
<!-- <nav class="settings-sidebar">
  <div class="sidebar-body">
    <a href="" class="settings-sidebar-toggler" (click)="toggleSettingsSidebar($event)">
      <i class="icon feather icon-settings"></i>
    </a>
    <div class="theme-wrapper">
      <h6 class="text-muted mb-2">Light Theme:</h6>
      <a class="theme-item" href="https://www.nobleui.com/angular/template/demo1/">
        <img src="assets/images/screenshots/light.jpg" alt="light theme">
      </a>
      <h6 class="text-muted mb-2">Dark Theme:</h6>
      <a class="theme-item active" href="https://www.nobleui.com/angular/template/demo2/">
        <img src="assets/images/screenshots/dark.jpg" alt="dark theme">
      </a>
    </div>
  </div>
</nav> -->
